import * as React from "react";
import "./ErrorMessage.scss";

interface Props {
  message: string | null;
}

export default ({ message }: Props) => {
  if (!message) {
    return null;
  }

  return (
    <div className="error-message">
      <div className="icon">
        <i className="fas fa-exclamation-triangle" />
      </div>
      <div className="message">{message}</div>
    </div>
  );
};
